import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { contribLegge59CkHelper } from './helpers/contrib-legge-59-92-form.helpers';

export const contribLegge59VIrregolaritaRules: FormGroupRules = {
    my_CkIrregPregL59: (form: FormGroup) => {
        contribLegge59CkHelper(form, 'my_gruppo7.my_CkIrregPregL59', 'my_CkVersamEffett', 0);
    },
};
